import React, { useState } from "react";
import clsx from "clsx";

import Loader from "./Loader";

import { DEFAULT_COLUMN, ICONS } from "../constants";

const AddFrom = ({ colSpan, columns = [], onSave, onCancel }) => {
  const [formData, setFromData] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const handleFieldChange = (_value, _name, event) => {
    if (event) {
      const { name, value } = event.currentTarget;
      setFromData((prevData) => ({ ...prevData, [name]: value }));
    } else {
      setFromData((prevData) => ({ ...prevData, [_name]: _value }));
    }
  };

  const handleSave = () => {
    setIsSaving(true);
    onSave(formData);
  };

  const _renderColumns = () => {
    return columns.map((column, columnIndex) => {
      const config = Object.assign({}, DEFAULT_COLUMN, column);

      if (!config.addable) return <td children="-" key={columnIndex} />;

      if (typeof config.addable === "function") {
        const Component = config.addable;
        return (
          <td
            key={columnIndex}
            children={<Component onChange={handleFieldChange} />}
          />
        );
      }

      return (
        <td key={columnIndex}>
          <input
            type="text"
            name={config.key}
            disabled={isSaving}
            placeholder={config.title}
            onChange={(e) => handleFieldChange(null, null, e)}
          />
        </td>
      );
    });
  };

  const isValidData = () => {
    const keysRequired = columns
      .map((col) => (col.required ? col.key : false))
      .filter((col) => col);

    const result = keysRequired.map((key) => {
      const value = formData[key];

      if (value && value.trim()) return true;
      else return false;
    });

    return !result.includes(false);
  };

  return (
    <tr className="datatable_edit">
      {colSpan > 0 && <td />}
      {_renderColumns()}
      <td className={clsx("datatable_actions", { loading: isSaving })}>
        {isSaving ? (
          <Loader />
        ) : (
          <>
            <span
              className={clsx("datatable_actions-save", {
                disabled: !isValidData(),
              })}
              onClick={handleSave}
              children={<ICONS.Check />}
            />
            <span
              className="datatable_actions-cancel"
              onClick={onCancel}
              children={<ICONS.Close />}
            />
          </>
        )}
      </td>
    </tr>
  );
};

export default AddFrom;
